import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-view-tracking',
  templateUrl: './view-tracking.component.html',
  styleUrls: ['./view-tracking.component.css']
})
export class ViewTrackingComponent implements OnInit {
  historialSolicitud: any;

  constructor(
    private dialogRef: MatDialogRef<ViewTrackingComponent>,
    private _userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.getTracking()
  }

  getTracking(){
    this._userService.httpGet('trackingSolicitud/'+this.data.solicitud).subscribe(resp => {
      this.historialSolicitud = resp.details;
    }, error => {
      console.log(error)
    });
  }

  cerrar(){
    this.dialogRef.close()
  }
}
